export * from './types/index.js';
export * from './lib/index.js';
export const PLUGIN_ASSETS_PREFIX = '/plugin-assets';
